/* istanbul ignore file */
import { IModuleClientFactory } from './module-client-factory-interface';
import { secureAxiosInstance, secureAxiosInstanceWithErrorMessageInterceptor } from './secure-axios-instance';
import {
  ICitizenInterviewClient,
  CitizenInterviewClient,
  ICitizenAgendaClient,
  CitizenAgendaClient,
  ICitizenCVClient,
  CitizenCVClient,
  ICitizenJoblogClient,
  CitizenJoblogClient,
  IFeatureTogglesClient,
  FeatureTogglesClient,
  ICitizenCommunicationClient,
  CitizenCommunicationClient,
  ICitizenCommunicationTemplatesClient,
  CitizenCommunicationTemplatesClient,
  ICompanyCommunicationTemplatesClient,
  CompanyCommunicationTemplatesClient,
  IOutboxClient,
  OutboxClient,
  SearchClient,
  ISearchClient,
  ICitizenClient,
  CitizenClient,
  SavedQueryClient,
  CitizenInterviewPreparationClient,
  ICitizenInterviewPreparationClient,
  ICitizenSurveysScreeningsClient,
  ICitizenSurveysProgressionClient,
  ICitizenSurveysForumFeedbackClient,
  ITranscriptionClient,
  TranscriptionClient,
  IForumCaseworkerClient,
} from './clients';
import { configuration } from '../configuration';
import {
  MultiSelectEntityLookupClient,
  IMultiSelectEntityLookupClient,
  IConfigurationClient,
  ConfigurationClient,
  ICitizenCaseClient,
  CitizenCaseClient,
  ICitizenVisitationAssistantClient,
  CitizenVisitationAssistantClient,
  ISavedQueryClient,
  IApplicationAreasClient,
  ApplicationAreasClient,
  IChartClient,
  ChartClient,
  ISavedChartClient,
  SavedChartClient,
  ICitizenJournalDocumentClient,
  CitizenJournalDocumentClient,
  IOfferAndActivityClient,
  OfferAndActivityClient,
  CitizenJournalClient,
  ICitizenJournalClient,
  ICitizenDiaryClient,
  CitizenDiaryClient,
  ILookupUserClient,
  LookupUserClient,
  ILookupTeamClient,
  LookupTeamClient,
  ILookupCompanyClient,
  LookupCompanyClient,
  ILookupOfferClient,
  LookupOfferClient,
  ILookupCitizenClient,
  LookupCitizenClient,
  ILookupContactPersonClient,
  LookupContactPersonClient,
  ICitizenJobnetRelationsContactGroupClient,
  CitizenJobnetRelationsContactGroupClient,
  ICitizenJobnetRelationsEnrollmentClient,
  CitizenJobnetRelationsEnrollmentClient,
  CitizenJobnetRelationsBenefitDecisionClient,
  ICitizenJobnetRelationsBenefitDecisionClient,
  CitizenCitizenMasterDataCitizenCoreClient,
  ICitizenCitizenMasterDataCitizenCoreClient,
  CitizenCitizenMasterDataParticularitiesClient,
  ICitizenCitizenMasterDataParticularitiesClient,
  ICitizenCitizenMasterDataCitizenPersonContactClient,
  CitizenCitizenMasterDataCitizenPersonContactClient,
  ICitizenAvailabilityClient,
  CitizenAvailabilityClient,
  IAuthorizationClient,
  AuthorizationClient,
  ICompanyCommunicationClient,
  CompanyCommunicationClient,
  ICitizenSocialIntegrationClient,
  CitizenSocialIntegrationClient,
  ICompanyRecruitmentsClient,
  CompanyRecruitmentsClient,
  ICitizenCommunicationCrowdLetterClient,
  CitizenCommunicationCrowdLetterClient,
  IDynamicLinksClient,
  DynamicLinksClient,
  ICompanyCommunicationCrowdLetterClient,
  CompanyCommunicationCrowdLetterClient,
  IOrganizationClient,
  OrganizationClient,
  ICompanyClient,
  CompanyClient,
  ICompanyDetailsClient,
  CompanyDetailsClient,
  CitizenPlanAndActivitiesClient,
  ICitizenPlanAndActivitiesClient,
  CitizenPlanAndActivitiesIncomeClient,
  ICitizenPlanAndActivitiesIncomeClient,
  CompanyAssociatedCaseWorkerClient,
  ICompanyAssociatedCaseWorkerClient,
  ICompanyCompanyTaskClient,
  CompanyCompanyTaskClient,
  ICitizenCitizenTaskClient,
  CitizenCitizenTaskClient,
  ICompanyContactPersonClient,
  CompanyContactPersonClient,
  ICompanyTradeCodesClient,
  CompanyTradeCodesClient,
  ICitizenCitizenMasterDataYouthEffortClient,
  CitizenCitizenMasterDataYouthEffortClient,
  IJobcenterTaskClient,
  JobcenterTaskClient,
  ICitizenSicknessBenefitPartialRecoveryClient,
  CitizenSicknessBenefitPartialRecoveryClient,
  ICompanySpecialCircumstanceClient,
  CompanySpecialCircumstanceClient,
  ICompanyTagsClient,
  CompanyTagsClient,
  IJobcenterTaskIncomingMailTasksClient,
  JobcenterTaskIncomingMailTasksClient,
  ICitizenAsylumClient,
  CitizenAsylumClient,
  CitizenSicknessBenefitMissingParticipationClient,
  ICitizenSicknessBenefitMissingParticipationClient,
  ICompanyAvailabilityClient,
  CompanyAvailabilityClient,
  IExternalOperatorClient,
  ExternalOperatorClient,
  ICitizenCitizenMasterDataPersonGroupClient,
  CitizenCitizenMasterDataPersonGroupClient,
  ICitizenJobnetRelationsJobcenterClient,
  CitizenJobnetRelationsJobcenterClient,
  ICompanyNotesClient,
  CompanyNotesClient,
  IJobcenterTaskGeneralTaskClient,
  JobcenterTaskGeneralTaskClient,
  ICitizenSicknessBenefitResumedWorkClient,
  CitizenSicknessBenefitResumedWorkClient,
  ICitizenSicknessBenefitBenefitExtensionAssessmentClient,
  CitizenSicknessBenefitBenefitExtensionAssessmentClient,
  CompanyAppointmentClient,
  ICompanyAppointmentClient,
  ICitizenSicknessBenefitClient,
  CitizenSicknessBenefitClient,
  IAdminAdminUIClient,
  AdminAdminUIClient,
  ICitizenJobnetRelationsJobnetClient,
  CitizenJobnetRelationsJobnetClient,
  ICitizenJobReferralClient,
  CitizenJobReferralClient,
  ICitizenGuideLinksClient,
  CitizenGuideLinksClient,
  ICitizenStandardPhrasesClient,
  CitizenStandardPhrasesClient,
  AdminAdminUIUsersClient,
  IAdminAdminUIUsersClient,
  IAdminAdminUISubJobcentersClient,
  AdminAdminUISubJobcentersClient,
  IAdminAdminUIUserProfilesClient,
  AdminAdminUIUserProfilesClient,
  ICitizenUnemploymentBenefitClient,
  CitizenUnemploymentBenefitClient,
  ICitizenDialogClient,
  CitizenDialogClient,
  CitizenChangeLogClient,
  ICitizenChangeLogClient,
  IAiSearchClient,
  AiSearchClient,
  ICompanyChangeLogClient,
  CompanyChangeLogClient,
  ICitizenTimelineClient,
  CitizenTimelineClient,
  CitizenCitizenOverviewClient,
  ICitizenCitizenOverviewClient,
  CitizenFlowOverviewClient,
  ICitizenFlowOverviewClient,
  IJobAdsClient,
  JobAdsClient,
  ICitizenGrantClient,
  CitizenGrantClient,
  ICitizenSicknessBenefitExpectedJobResumptionClient,
  CitizenSicknessBenefitExpectedJobResumptionClient,
  CompanyFvdbClient,
  ICompanyFvdbClient,
  DstIntegrationClient,
  IDstIntegrationClient,
  ISurveyClient,
  SurveyClient,
  ICitizenAssessmentClient,
  CitizenAssessmentClient,
  IAdminAdminUISurveyClient,
  AdminAdminUISurveyClient,
  IAdminAdminUICoPaymentClient,
  AdminAdminUICoPaymentClient,
  ICitizenJournalReportClient,
  CitizenJournalReportClient,
  ICitizenAssignmentClient,
  CitizenAssignmentClient,
  ICitizenEducationEventClient,
  CitizenEducationEventClient,
  IAdminAdminUIGrantTypesClient,
  AdminAdminUIGrantTypesClient,
  IAdminAdminUIVisitationTeamsClient,
  AdminAdminUIVisitationTeamsClient,
  IAdminAdminUIInterviewTypesClient,
  AdminAdminUIInterviewTypesClient,
  IAdminAdminUIJournalNoteContentTypesClient,
  AdminAdminUIJournalNoteContentTypesClient,
  IAdminAdminUIMethodTypesClient,
  AdminAdminUIMethodTypesClient,
  IAdminAdminUIObservationTypesClient,
  AdminAdminUIObservationTypesClient,
  IAdminAdminUIAIClient,
  AdminAdminUIAIClient,
  ICitizenRulingClient,
  CitizenRulingClient,
  ICitizenRulingComplaintClient,
  CitizenRulingComplaintClient,
  ICitizenClarificationRightClient,
  CitizenClarificationRightClient,
  ICitizenCounselingInquiriesClient,
  CitizenCounselingInquiriesClient,
  ICitizenCitizenMasterDataDfdgHistoriesClient,
  CitizenCitizenMasterDataDfdgHistoriesClient,
  CitizenSurveysScreeningsClient,
  CitizenSurveysProgressionClient,
  CitizenSurveysForumFeedbackClient,
  ForumCaseworkerClient,
  ICompanyCompanyVisitPreparationClient,
  CompanyCompanyVisitPreparationClient,
  ICitizenCitizenMasterDataSustenanceHistoryClient,
  CitizenCitizenMasterDataSustenanceHistoryClient,
  ICitizenMedicalCollaborationClient,
  CitizenMedicalCollaborationClient,
  IAttendanceClient,
  AttendanceClient,
  IAdminCitizenDeletionClient,
  AdminCitizenDeletionClient,
  CitizenServiceProviderReceiveCitizenClient,
  ICitizenServiceProviderReceiveCitizenClient,
  CitizenServiceProviderReceiveAssignmentClient,
  ICitizenServiceProviderReceiveAssignmentClient,
  CitizenServiceProviderFordelingClient,
  ICitizenServiceProviderFordelingClient,
  CitizenServiceProviderSendMessageToAuthorityClient,
  ICitizenServiceProviderSendMessageToAuthorityClient,
  CitizenServiceProviderClient,
  ICitizenServiceProviderClient,
  CitizenServiceProviderObservationsClient,
  ICitizenServiceProviderObservationsClient,
  CitizenServiceProviderInterventionObjectiveStatusClient,
  ICitizenServiceProviderInterventionObjectiveStatusClient,
  CitizenServiceProviderCalendarClient,
  ICitizenServiceProviderCalendarClient,
  CitizenServiceProviderCitizenDescriptionClient,
  ICitizenServiceProviderCitizenDescriptionClient,
  CitizenServiceProviderSpLinkClient,
  ICitizenServiceProviderSpLinkClient,
  CitizenServiceProviderTrafficLightsClient,
  ICitizenServiceProviderTrafficLightsClient,
  CitizenServiceProviderHealthOverviewClient,
  ICitizenServiceProviderHealthOverviewClient,
  CitizenServiceProviderCitizenNotesClient,
  ICitizenServiceProviderCitizenNotesClient,
  CitizenServiceProviderMedicinePricesClient,
  ICitizenServiceProviderMedicinePricesClient,
  CitizenServiceProviderAiDemoClient,
  ICitizenServiceProviderAiDemoClient,
  CitizenServiceProviderMedicineCardClient,
  ICitizenServiceProviderMedicineCardClient,
  CitizenServiceProviderMedicineInventoryClient,
  ICitizenServiceProviderMedicineInventoryClient,
  CitizenServiceProviderUseOfForceClient,
  ICitizenServiceProviderUseOfForceClient,
  CitizenUseOfForceAssessmentClient,
  ICitizenUseOfForceAssessmentClient,
  CitizenUseOfForceAuthorizationClient,
  ICitizenUseOfForceAuthorizationClient,
  IAttendanceProtocolClient,
  AttendanceProtocolClient,
  IOfferAndActivityCoPaymentClient,
  OfferAndActivityCoPaymentClient,
  ICitizenCvSearchClient,
  CitizenCvSearchClient,
  ILookupCaseClient,
  LookupCaseClient,
  IServiceProviderUnitCalendarClient,
  ServiceProviderUnitCalendarClient,
  IServiceProviderUnitUseOfForceClient,
  ServiceProviderUnitUseOfForceClient,
  IServiceProviderUnitResourceUtilizationClient,
  ServiceProviderUnitResourceUtilizationClient,
  IServiceProviderUnitOverviewClient,
  ServiceProviderUnitOverviewClient,
  IManagementInformationInterventionLadderClient,
  ManagementInformationInterventionLadderClient,
} from './clients/auto-generated-clients';

export class ModuleClientFactory implements IModuleClientFactory {
  private readonly baseUrl: string;

  constructor(baseUrl?: string | undefined) {
    this.baseUrl = baseUrl ?? configuration.bffBaseAddress?.replace('/api', ''); // HACK: Change bffBaseAddress to not include 'api' when all legacy clients have been removed
  }

  createCompanyNotesClient(withErrorMessageInterceptor?: boolean | undefined): ICompanyNotesClient {
    return new CompanyNotesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanySpecialCircumstanceClient(withErrorMessageInterceptor = false): ICompanySpecialCircumstanceClient {
    return new CompanySpecialCircumstanceClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyRecruitmentsClient(): ICompanyRecruitmentsClient {
    return new CompanyRecruitmentsClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenCVClient(withErrorMessageInterceptor = false): ICitizenCVClient {
    return new CitizenCVClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenCaseClient(withErrorMessageInterceptor = false): ICitizenCaseClient {
    return new CitizenCaseClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenVisitationAssistantClient(withErrorMessageInterceptor = false): ICitizenVisitationAssistantClient {
    return new CitizenVisitationAssistantClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  // eslint-disable-next-line class-methods-use-this
  createCitizenClient(withErrorMessageInterceptor = false): ICitizenClient {
    return new CitizenClient(configuration.bffBase, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenCitizenMasterDataYouthEffortClient(): ICitizenCitizenMasterDataYouthEffortClient {
    return new CitizenCitizenMasterDataYouthEffortClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenJoblogClient(withErrorMessageInterceptor = true): ICitizenJoblogClient {
    return new CitizenJoblogClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenInterviewClient(withErrorMessageInterceptor = false): ICitizenInterviewClient {
    return new CitizenInterviewClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenAgendaClient(withErrorMessageInterceptor = false): ICitizenAgendaClient {
    return new CitizenAgendaClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenJobsearchClient(): ICitizenInterviewClient {
    return new CitizenInterviewClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenJobReferralClient(): ICitizenJobReferralClient {
    return new CitizenJobReferralClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenCommunicationClient(withErrorMessageInterceptor = false): ICitizenCommunicationClient {
    return new CitizenCommunicationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createOutboxClient(): IOutboxClient {
    return new OutboxClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenCommunicationTemplatesClient(): ICitizenCommunicationTemplatesClient {
    return new CitizenCommunicationTemplatesClient(this.baseUrl, secureAxiosInstance);
  }

  createCompanyCommunicationTemplatesClient(): ICompanyCommunicationTemplatesClient {
    return new CompanyCommunicationTemplatesClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenInterviewPreparationClient(): ICitizenInterviewPreparationClient {
    return new CitizenInterviewPreparationClient(this.baseUrl, secureAxiosInstance);
  }

  createSearchClient(withErrorMessageInterceptor = false): ISearchClient {
    return new SearchClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createFeatureToggleClient(): IFeatureTogglesClient {
    return new FeatureTogglesClient(this.baseUrl, secureAxiosInstance);
  }

  createMultiSelectEntityLookupClient(): IMultiSelectEntityLookupClient {
    return new MultiSelectEntityLookupClient(this.baseUrl, secureAxiosInstance);
  }

  createConfigurationClient(): IConfigurationClient {
    return new ConfigurationClient(this.baseUrl, secureAxiosInstance);
  }

  createSavedQueryClient(): ISavedQueryClient {
    return new SavedQueryClient(this.baseUrl, secureAxiosInstance);
  }
  createSavedChartClient(): ISavedChartClient {
    return new SavedChartClient(this.baseUrl, secureAxiosInstance);
  }
  createApplicationAreaClient(): IApplicationAreasClient {
    return new ApplicationAreasClient(this.baseUrl, secureAxiosInstance);
  }
  createChartClient(): IChartClient {
    return new ChartClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenJournalDocumentClient(): ICitizenJournalDocumentClient {
    return new CitizenJournalDocumentClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenJournalReportClient(): ICitizenJournalReportClient {
    return new CitizenJournalReportClient(this.baseUrl, secureAxiosInstance);
  }

  createOfferAndActivityClient(withErrorMessageInterceptor = false): IOfferAndActivityClient {
    return new OfferAndActivityClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createOfferAndActivityCoPaymentClient(withErrorMessageInterceptor = false): IOfferAndActivityCoPaymentClient {
    return new OfferAndActivityCoPaymentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  // eslint-disable-next-line class-methods-use-this
  createCitizenJournalClient(): ICitizenJournalClient {
    return new CitizenJournalClient(configuration.bffBase, secureAxiosInstance);
  }

  createLookupCitizenClient(): ILookupCitizenClient {
    return new LookupCitizenClient(this.baseUrl, secureAxiosInstance);
  }

  createLookupUserClient(): ILookupUserClient {
    return new LookupUserClient(this.baseUrl, secureAxiosInstance);
  }

  createLookupTeamClient(): ILookupTeamClient {
    return new LookupTeamClient(this.baseUrl, secureAxiosInstance);
  }

  createLookupCompanyClient(): ILookupCompanyClient {
    return new LookupCompanyClient(this.baseUrl, secureAxiosInstance);
  }

  createLookupOfferClient(): ILookupOfferClient {
    return new LookupOfferClient(this.baseUrl, secureAxiosInstance);
  }

  createLookupContactPersonClient(): ILookupContactPersonClient {
    return new LookupContactPersonClient(this.baseUrl, secureAxiosInstance);
  }

  createLookupCaseClient(): ILookupCaseClient {
    return new LookupCaseClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenContactGroupClient(): ICitizenJobnetRelationsContactGroupClient {
    return new CitizenJobnetRelationsContactGroupClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenBenefitDecisionClient(): ICitizenJobnetRelationsBenefitDecisionClient {
    return new CitizenJobnetRelationsBenefitDecisionClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenEnrollmentClient(withErrorMessageInterceptor = false): ICitizenJobnetRelationsEnrollmentClient {
    return new CitizenJobnetRelationsEnrollmentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenJobcenterClient(withErrorMessageInterceptor = false): ICitizenJobnetRelationsJobcenterClient {
    return new CitizenJobnetRelationsJobcenterClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenCitizenMasterDataCitizenCoreClient(): ICitizenCitizenMasterDataCitizenCoreClient {
    return new CitizenCitizenMasterDataCitizenCoreClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenCitizenMasterDataParticularitiesClient(): ICitizenCitizenMasterDataParticularitiesClient {
    return new CitizenCitizenMasterDataParticularitiesClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenMasterDataCitizenPersonContactClient(): ICitizenCitizenMasterDataCitizenPersonContactClient {
    return new CitizenCitizenMasterDataCitizenPersonContactClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenAvailabilityClient(withErrorMessageInterceptor?: boolean): ICitizenAvailabilityClient {
    return new CitizenAvailabilityClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAuthorizationClient(): IAuthorizationClient {
    return new AuthorizationClient(this.baseUrl, secureAxiosInstance);
  }

  createCompanyCommunicationClient(): ICompanyCommunicationClient {
    return new CompanyCommunicationClient(this.baseUrl, secureAxiosInstance);
  }

  createSocialIntegrationClient(): ICitizenSocialIntegrationClient {
    return new CitizenSocialIntegrationClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenCommunicationCrowdLetterClient(): ICitizenCommunicationCrowdLetterClient {
    return new CitizenCommunicationCrowdLetterClient(this.baseUrl, secureAxiosInstance);
  }

  createCompanyCommunicationCrowdLetterClient(): ICompanyCommunicationCrowdLetterClient {
    return new CompanyCommunicationCrowdLetterClient(this.baseUrl, secureAxiosInstance);
  }
  createDynamicLinkClient(withErrorMessageInterceptor = true): IDynamicLinksClient {
    return new DynamicLinksClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createOrganizationClient(withErrorMessageInterceptor = false): IOrganizationClient {
    return new OrganizationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyClient(withErrorMessageInterceptor = false): ICompanyClient {
    return new CompanyClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyDetailsClient(withErrorMessageInterceptor = false): ICompanyDetailsClient {
    return new CompanyDetailsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenPlanAndActivitiesClient(withErrorMessageInterceptor = false): ICitizenPlanAndActivitiesClient {
    return new CitizenPlanAndActivitiesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenPlanAndActivitiesIncomeClient(withErrorMessageInterceptor = false): ICitizenPlanAndActivitiesIncomeClient {
    return new CitizenPlanAndActivitiesIncomeClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyAssociatedCaseWorkerClient(withErrorMessageInterceptor = false): ICompanyAssociatedCaseWorkerClient {
    return new CompanyAssociatedCaseWorkerClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyTaskClient(withErrorMessageInterceptor = true): ICompanyCompanyTaskClient {
    return new CompanyCompanyTaskClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenTaskClient(withErrorMessageInterceptor = true): ICitizenCitizenTaskClient {
    return new CitizenCitizenTaskClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createJobcenterTaskClient(withErrorMessageInterceptor = true): IJobcenterTaskClient {
    return new JobcenterTaskClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createGeneralTaskClient(withErrorMessageInterceptor = true): IJobcenterTaskGeneralTaskClient {
    return new JobcenterTaskGeneralTaskClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyContactPersonClient(withErrorMessageInterceptor = false): ICompanyContactPersonClient {
    return new CompanyContactPersonClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenCitizenMasterDataCitizenPersonContactClient(withErrorMessageInterceptor = true): ICitizenCitizenMasterDataCitizenPersonContactClient {
    return new CitizenCitizenMasterDataCitizenPersonContactClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyTradeCodesClient(withErrorMessageInterceptor = false): ICompanyTradeCodesClient {
    return new CompanyTradeCodesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyTagsClient(withErrorMessageInterceptor = false): ICompanyTagsClient {
    return new CompanyTagsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenSicknessBenefitPartialRecoveryClient(): ICitizenSicknessBenefitPartialRecoveryClient {
    return new CitizenSicknessBenefitPartialRecoveryClient(this.baseUrl, secureAxiosInstance);
  }

  createCitizenSicknessBenefitExpectedJobResumptionClient(): ICitizenSicknessBenefitExpectedJobResumptionClient {
    return new CitizenSicknessBenefitExpectedJobResumptionClient(this.baseUrl, secureAxiosInstance);
  }
  createCitizenSicknessBenefitClient(): ICitizenSicknessBenefitClient {
    return new CitizenSicknessBenefitClient(this.baseUrl, secureAxiosInstance);
  }

  createAsylumClient(withErrorMessageInterceptor?: boolean | undefined): ICitizenAsylumClient {
    return new CitizenAsylumClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createIncomingMailTaskClient(withErrorMessageInterceptor = false): IJobcenterTaskIncomingMailTasksClient {
    return new JobcenterTaskIncomingMailTasksClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenSicknessBenefitMissingParticipationClient(withErrorMessageInterceptor = true): ICitizenSicknessBenefitMissingParticipationClient {
    return new CitizenSicknessBenefitMissingParticipationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenSicknessBenefitBenefitExtensionAssessmentClient(withErrorMessageInterceptor = true): ICitizenSicknessBenefitBenefitExtensionAssessmentClient {
    return new CitizenSicknessBenefitBenefitExtensionAssessmentClient(
      this.baseUrl,
      withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance
    );
  }

  createCompanyAvailabilityClient(withErrorMessageInterceptor: boolean): ICompanyAvailabilityClient {
    return new CompanyAvailabilityClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createExternalOperatorClient(withErrorMessageInterceptor = true): IExternalOperatorClient {
    return new ExternalOperatorClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createPersonGroupClient(withErrorMessageInterceptor = false): ICitizenCitizenMasterDataPersonGroupClient {
    return new CitizenCitizenMasterDataPersonGroupClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenSicknessBenefitResumedWorkClient(withErrorMessageInterceptor = false): ICitizenSicknessBenefitResumedWorkClient {
    return new CitizenSicknessBenefitResumedWorkClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCompanyAppointmentClient(withErrorMessageInterceptor = false): ICompanyAppointmentClient {
    return new CompanyAppointmentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAdminUIClient(withErrorMessageInterceptor = true): IAdminAdminUIClient {
    return new AdminAdminUIClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAdminUIAIClient(withErrorMessageInterceptor = true): IAdminAdminUIAIClient {
    return new AdminAdminUIAIClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAdminUIUsersClient(withErrorMessageInterceptor = false): IAdminAdminUIUsersClient {
    return new AdminAdminUIUsersClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAdminUIJobcentersClient(withErrorMessageInterceptor = false): IAdminAdminUISubJobcentersClient {
    return new AdminAdminUISubJobcentersClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAdminUIGrantTypesClient(withErrorMessageInterceptor = false): IAdminAdminUIGrantTypesClient {
    return new AdminAdminUIGrantTypesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createAdminUIVisitationTeamsClient(withErrorMessageInterceptor = false): IAdminAdminUIVisitationTeamsClient {
    return new AdminAdminUIVisitationTeamsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createUserProfilesClient(withErrorMessageInterceptor = false): IAdminAdminUIUserProfilesClient {
    return new AdminAdminUIUserProfilesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenJobnetRelationsJobnetClient(withErrorMessageInterceptor = false): ICitizenJobnetRelationsJobnetClient {
    return new CitizenJobnetRelationsJobnetClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createGuideLinksClient(withErrorMessageInterceptor = false): ICitizenGuideLinksClient {
    return new CitizenGuideLinksClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenStandardPhrasesClient(withErrorMessageInterceptor = false): ICitizenStandardPhrasesClient {
    return new CitizenStandardPhrasesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenUnemploymentBenefitClient(withErrorMessageInterceptor = true): ICitizenUnemploymentBenefitClient {
    return new CitizenUnemploymentBenefitClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenDialogClient(withErrorMessageInterceptor = true): ICitizenDialogClient {
    return new CitizenDialogClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createSurveyClient(withErrorMessageInterceptor = true): ISurveyClient {
    return new SurveyClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenChangeLogClient(withErrorMessageInterceptor = true): ICitizenChangeLogClient {
    return new CitizenChangeLogClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCompanyChangeLogClient(withErrorMessageInterceptor = true): ICompanyChangeLogClient {
    return new CompanyChangeLogClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAiSearchClient(withErrorMessageInterceptor = true): IAiSearchClient {
    return new AiSearchClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenTimelineClient(withErrorMessageInterceptor = true): ICitizenTimelineClient {
    return new CitizenTimelineClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenCitizenOverviewClient(withErrorMessageInterceptor = true): ICitizenCitizenOverviewClient {
    return new CitizenCitizenOverviewClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenFlowOverviewClient(withErrorMessageInterceptor = true): ICitizenFlowOverviewClient {
    return new CitizenFlowOverviewClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createJobAdsClient(withErrorMessageInterceptor = true): IJobAdsClient {
    return new JobAdsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenGrantClient(withErrorMessageInterceptor?: boolean): ICitizenGrantClient {
    return new CitizenGrantClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenRulingClient(withErrorMessageInterceptor = true): ICitizenRulingClient {
    return new CitizenRulingClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenRulingComplaintClient(withErrorMessageInterceptor = true): ICitizenRulingComplaintClient {
    return new CitizenRulingComplaintClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenClarificationRightClient(withErrorMessageInterceptor = true): ICitizenClarificationRightClient {
    return new CitizenClarificationRightClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenCounselingInquiriesClient(withErrorMessageInterceptor = true): ICitizenCounselingInquiriesClient {
    return new CitizenCounselingInquiriesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCompanyFvdbClient(withErrorMessageInterceptor = true): ICompanyFvdbClient {
    return new CompanyFvdbClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createDstIntegrationClient(withErrorMessageInterceptor = true): IDstIntegrationClient {
    return new DstIntegrationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenAssessmentClient(withErrorMessageInterceptor = true): ICitizenAssessmentClient {
    return new CitizenAssessmentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAdminUISurveyClient(withErrorMessageInterceptor = true): IAdminAdminUISurveyClient {
    return new AdminAdminUISurveyClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAdminUICoPaymentClient(withErrorMessageInterceptor = true): IAdminAdminUICoPaymentClient {
    return new AdminAdminUICoPaymentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAdminUIInterviewTypesClient(withErrorMessageInterceptor = true): IAdminAdminUIInterviewTypesClient {
    return new AdminAdminUIInterviewTypesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAdminUIJournalNoteContentTypesClient(withErrorMessageInterceptor = true): IAdminAdminUIJournalNoteContentTypesClient {
    return new AdminAdminUIJournalNoteContentTypesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAdminUIMethodTypesClient(withErrorMessageInterceptor = true): IAdminAdminUIMethodTypesClient {
    return new AdminAdminUIMethodTypesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAdminUIObservationTypesClient(withErrorMessageInterceptor = true): IAdminAdminUIObservationTypesClient {
    return new AdminAdminUIObservationTypesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenAssignmentClient(withErrorMessageInterceptor?: boolean): ICitizenAssignmentClient {
    return new CitizenAssignmentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenEducationEventClient(withErrorMessageInterceptor?: boolean): ICitizenEducationEventClient {
    return new CitizenEducationEventClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenCitizenMasterDataDfdgHistoriesClient(withErrorMessageInterceptor?: boolean): ICitizenCitizenMasterDataDfdgHistoriesClient {
    return new CitizenCitizenMasterDataDfdgHistoriesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenCitizenMasterDataSustenanceHistoryClient(withErrorMessageInterceptor?: boolean): ICitizenCitizenMasterDataSustenanceHistoryClient {
    return new CitizenCitizenMasterDataSustenanceHistoryClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenDiaryClient(): ICitizenDiaryClient {
    return new CitizenDiaryClient(this.baseUrl, secureAxiosInstanceWithErrorMessageInterceptor);
  }
  createCitizenSurveysScreeningsClient(withErrorMessageInterceptor?: boolean): ICitizenSurveysScreeningsClient {
    return new CitizenSurveysScreeningsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenSurveysProgressionClient(withErrorMessageInterceptor?: boolean): ICitizenSurveysProgressionClient {
    return new CitizenSurveysProgressionClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenSurveysForumFeedbackClient(withErrorMessageInterceptor?: boolean): ICitizenSurveysForumFeedbackClient {
    return new CitizenSurveysForumFeedbackClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createForumCaseworkerClient(withErrorMessageInterceptor = true): IForumCaseworkerClient {
    return new ForumCaseworkerClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCompanyCompanyVisitPreparationClient(withErrorMessageInterceptor?: boolean): ICompanyCompanyVisitPreparationClient {
    return new CompanyCompanyVisitPreparationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenMedicalCollaborationClient(withErrorMessageInterceptor?: boolean): ICitizenMedicalCollaborationClient {
    return new CitizenMedicalCollaborationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAttendanceClient(withErrorMessageInterceptor = true): IAttendanceClient {
    return new AttendanceClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createAttendanceProtocolClient(withErrorMessageInterceptor = true): IAttendanceProtocolClient {
    return new AttendanceProtocolClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createTranscriptionClientWithoutErrorInterceptor(): ITranscriptionClient {
    return new TranscriptionClient(this.baseUrl, secureAxiosInstance);
  }
  createAdminCitizenDeletionClient(): IAdminCitizenDeletionClient {
    return new AdminCitizenDeletionClient(this.baseUrl, secureAxiosInstance);
  }
  createCitizenServiceProviderClient(withErrorMessageInterceptor = true): ICitizenServiceProviderClient {
    return new CitizenServiceProviderClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderObservationsClient(withErrorMessageInterceptor = true): ICitizenServiceProviderObservationsClient {
    return new CitizenServiceProviderObservationsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderReceiveCitizenClient(withErrorMessageInterceptor = false): ICitizenServiceProviderReceiveCitizenClient {
    return new CitizenServiceProviderReceiveCitizenClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderReceiveAssignmentClient(withErrorMessageInterceptor = true): ICitizenServiceProviderReceiveAssignmentClient {
    return new CitizenServiceProviderReceiveAssignmentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderFordelingClient(withErrorMessageInterceptor = true): ICitizenServiceProviderFordelingClient {
    return new CitizenServiceProviderFordelingClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderSendMessageToAuthorityClient(withErrorMessageInterceptor = true): ICitizenServiceProviderSendMessageToAuthorityClient {
    return new CitizenServiceProviderSendMessageToAuthorityClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderInterventionObjectiveStatusClient(withErrorMessageInterceptor = true): ICitizenServiceProviderInterventionObjectiveStatusClient {
    return new CitizenServiceProviderInterventionObjectiveStatusClient(
      this.baseUrl,
      withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance
    );
  }
  createCitizenServiceProviderCalendarClient(withErrorMessageInterceptor = true): ICitizenServiceProviderCalendarClient {
    return new CitizenServiceProviderCalendarClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createCitizenCvSearchClient(withErrorMessageInterceptor = true): ICitizenCvSearchClient {
    return new CitizenCvSearchClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }

  createServiceProviderUnitCalendarClient(withErrorMessageInterceptor = true): IServiceProviderUnitCalendarClient {
    return new ServiceProviderUnitCalendarClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createServiceProviderCitizenDescriptionClient(withErrorMessageInterceptor = true): ICitizenServiceProviderCitizenDescriptionClient {
    return new CitizenServiceProviderCitizenDescriptionClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createServiceProviderSpLinkClient(withErrorMessageInterceptor = true): ICitizenServiceProviderSpLinkClient {
    return new CitizenServiceProviderSpLinkClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderTrafficLightsClient(withErrorMessageInterceptor = true): ICitizenServiceProviderTrafficLightsClient {
    return new CitizenServiceProviderTrafficLightsClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderHealthOverviewClient(withErrorMessageInterceptor = true): ICitizenServiceProviderHealthOverviewClient {
    return new CitizenServiceProviderHealthOverviewClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderCitizenNotesClient(withErrorMessageInterceptor = true): ICitizenServiceProviderCitizenNotesClient {
    return new CitizenServiceProviderCitizenNotesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderMedicinePricesClient(withErrorMessageInterceptor = true): ICitizenServiceProviderMedicinePricesClient {
    return new CitizenServiceProviderMedicinePricesClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderAiDemoClient(withErrorMessageInterceptor = true): ICitizenServiceProviderAiDemoClient {
    return new CitizenServiceProviderAiDemoClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderMedicineCardClient(withErrorMessageInterceptor = true): ICitizenServiceProviderMedicineCardClient {
    return new CitizenServiceProviderMedicineCardClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderMedicineInventoryClient(withErrorMessageInterceptor = true): ICitizenServiceProviderMedicineInventoryClient {
    return new CitizenServiceProviderMedicineInventoryClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenServiceProviderUseOfForceClient(withErrorMessageInterceptor = true): ICitizenServiceProviderUseOfForceClient {
    return new CitizenServiceProviderUseOfForceClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenUseOfForceAssessmentClient(withErrorMessageInterceptor = true): ICitizenUseOfForceAssessmentClient {
    return new CitizenUseOfForceAssessmentClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createCitizenUseOfForceAuthorizationClient(withErrorMessageInterceptor = true): ICitizenUseOfForceAuthorizationClient {
    return new CitizenUseOfForceAuthorizationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createServiceProviderUnitUseOfForceClient(withErrorMessageInterceptor = true): IServiceProviderUnitUseOfForceClient {
    return new ServiceProviderUnitUseOfForceClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createServiceProviderUnitResourceUtilizationClient(withErrorMessageInterceptor = true): IServiceProviderUnitResourceUtilizationClient {
    return new ServiceProviderUnitResourceUtilizationClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createServiceProviderUnitOverviewClient(withErrorMessageInterceptor = true): IServiceProviderUnitOverviewClient {
    return new ServiceProviderUnitOverviewClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
  createManagementInformationInterventionLadderClient(withErrorMessageInterceptor = true): IManagementInformationInterventionLadderClient {
    return new ManagementInformationInterventionLadderClient(this.baseUrl, withErrorMessageInterceptor ? secureAxiosInstanceWithErrorMessageInterceptor : secureAxiosInstance);
  }
}

export const moduleClientFactory: IModuleClientFactory = new ModuleClientFactory();
